import {Component, OnInit} from '@angular/core';
import {NgbDateParserFormatter, NgbDatepickerI18n} from '@ng-bootstrap/ng-bootstrap';
import {NgbDateItParserFormatter} from '../../../component/date-custom/ngb-date-it-parser-formatter';
import {CustomDatepickerI18n, I18n} from '../../../component/date-custom/ng-bootstrap-datepicker-i18n';
import {Subject} from 'rxjs/Subject';
import {BsModalRef} from 'ngx-bootstrap';
import {MediaService} from "../../../media/media.service";


@Component({
  selector: 'app-galleria-corso',
  templateUrl: './galleria.component.html',
  providers: [
    I18n,
    {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n},
    {provide: NgbDateParserFormatter, useClass: NgbDateItParserFormatter}
  ]
})

export class GalleriaComponent implements OnInit {

  imageGallery: any[] = [];
  imageSelected: any;
  mediaType: any;

  public onClose: Subject<any>;

  constructor(
    public bsModalRef: BsModalRef,
    public mediaService: MediaService
  ) {
  }

  ngOnInit() {
    this.onClose = new Subject();

    if (this.mediaType){
      this.mediaService.getAllMediaByType(this.mediaType).subscribe((res) => {
        this.imageGallery = res;
      });
    } else {
      /*this.mediaService.getAllMedia().subscribe((res) => {
        this.imageGallery = res;
      });*/
      this.mediaService.getAllMediaByType('M').subscribe((res) => {
        this.imageGallery = res;
      });
    }

  }

  clickImage(item: any){
    if(item.checked){
      item.checked = false
    }else{
      for (let i of item){
        i.checked = false
      }
      item.checked = true
      this.imageSelected = item;
    }
  }

  select(){
    this.onClose.next(this.imageSelected);
  }

}



// WEBPACK FOOTER //
// ./src/app/servizi/formativa/galleria/galleria.component.ts